/**
 * Action type to set a feature control toggle.
 *
 * {
 *     type: SET_FEATURE_CONTROL,
 *     feature: string,
 *     enabled: boolean
 * }
 */
export const SET_FEATURE_CONTROL = 'SET_FEATURE_CONTROL';
/**
 * Action type to update all feature controls at once (e.g. from metadata sync).
 *
 * {
 *     type: UPDATE_FEATURE_CONTROLS,
 *     featureControls: Record<string, boolean>
 * }
 */
export const UPDATE_FEATURE_CONTROLS = 'UPDATE_FEATURE_CONTROLS';
